import { createTheme } from '@mui/material/styles';
import { MUI_BREAKPOINT_VALUES } from './features/common/viewportBreakpoints';

export { isAltDev, isLocalDev, isStaging } from './themeEnvironment';

export const darkTheme = createTheme({
  breakpoints: {
    values: MUI_BREAKPOINT_VALUES,
  },
  palette: {
    mode: 'dark',
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '@media (hover: none), (pointer: coarse)': {
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
    },
  },
});
